require('./bootstrap');

import PortalVue from "portal-vue";

Vue.use(PortalVue);

if (window.Highcharts === undefined) {
    window.Highcharts = require('highcharts');
}

window.Highcharts.setOptions({
    chart: {
        zoomType: 'x',
        type: 'spline'
    },
    xAxis: {
        type: 'datetime',
        title: {
            text: null
        }
    },
    yAxis: {
        title: {
            text: 'values'
        }
    },
    series: [],
});

// export charts
require('highcharts/modules/exporting')(window.Highcharts);
require('highcharts/modules/map')(window.Highcharts);
require('highcharts/modules/variwide')(window.Highcharts);
